import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface HolderCardComponentProps {
  lastName: string;
  firstName: string;
  email: string;
}

export const HolderCardComponent = ({
  lastName,
  firstName,
  email,
}: HolderCardComponentProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <Card gap={GapEnum.M} flex={1}>
      <AccentTitle
        icon="building-01"
        as={HeadingEnum.H2}
        text={t('delmonicos-shared-sdk.outputs-customer.holder')}
      />

      <Stack gap={GapEnum.M} direction="column">
        <Stack justifyContent="space-between" flex={1}>
          <Text bold>
            {t('delmonicos-shared-sdk.outputs-holder.last-name')}
          </Text>
          <Text>{lastName}</Text>
        </Stack>
        <Stack justifyContent="space-between" flex={1}>
          <Text bold>
            {t('delmonicos-shared-sdk.outputs-holder.first-name')}
          </Text>
          <Text>{firstName}</Text>
        </Stack>
        <Stack justifyContent="space-between">
          <Text bold>
            <Icon name="mail-01" />
            {t('delmonicos-shared-sdk.outputs-holder.email')}
          </Text>
          <Text>{email}</Text>
        </Stack>
      </Stack>
    </Card>
  );
};
